import React from 'react'
import { connect } from 'react-redux'
import { closeFeedbackDialogue } from '../../actioncreators/actioncreators'
import styled from 'styled-components'

const { Component } = React

const Modal = styled.div`
  display: none;
  position: fixed;
  z-index: 10001;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: none;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
`

const Dialogue = styled.div`
  background-color: #fefefe;
  margin: 10% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 60%;
  border-radius: 5px;
`

class FeedbackDialogue extends Component {
  render () {
    return (
      <Modal style={{ display: this.props.displayFeedbackDialogue ? 'block' : 'none' }} onClick={this.props.close}>
        <Dialogue onClick={this.props.stopPropagation}>
          <h3>Feedback</h3>
          <p>Please use this form to contact us when you have an issue, an idea for a feature or just want to get in touch.</p>
          <iframe title='Feedback Form' class='freshwidget-embedded-form' id='freshwidget-embedded-form' src='https://teamuplabs.freshdesk.com/widgets/feedback_widget/new?&widgetType=embedded&formTitle=&screenshot=No&searchArea=no' scrolling='no' height='500px' width='100%' frameborder='0' />
          <div className='text-right' style={{ marginTop: 20 }}>
            <span id='copyFeedback' style={{ marginRight: 20, fontWeight: 'bold' }}>&nbsp;</span>
            <button type='button' className='btn btn-default' onClick={this.props.close}>Close</button>&nbsp;
          </div>
        </Dialogue>
      </Modal>
    )
  }
}

const mapStateToProps = function (store, ownProps) {
  return {
    displayFeedbackDialogue: store.general.displayFeedbackDialogue
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    close: () => { dispatch(closeFeedbackDialogue()) },
    stopPropagation: (e) => { e.stopPropagation() }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackDialogue)
